<template>
  <Modal id="userStatusModal" data-bs-backdrop="static">
    <template #header>
      <h5 class="modal-title">{{ userStatusModalData['status'] == 'ACTIVED' ? $t('key_modal_disable'): $t('key_modal_enable') }}</h5>
    </template>
    <template #body>
      <div v-if="userStatusModalData['status'] == 'ACTIVED'" class="row">
        <p>
          {{ $t('key_modal_markAsDisabled') }}
        </p>
      </div>
      <div v-else>
        <p>
          {{ $t('key_modal_markAsEnabled') }}
        </p>
      </div>
    </template>
    <template #footer>
      <button ref="closeButton" type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">
        {{ $t('key_cancel') }}
      </button>
      <button type="button" class="btn bg-gradient-primary" @click="confirmUserStatus">
        {{ $t('key_confirm') }}
      </button>
    </template>
  </Modal>
</template>
  
<script>
import Modal from "@/components/ModalHotakauth.vue";
export default {
  components: { Modal },
  props: {
    userStatusModalData: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['confirm-user-status'],
  computed: {
    newUsuario() {
      return this.$store.state.user.newUser.status;
    },
  },
  created() {
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.hideModal();
      }
    });
  },
  methods: {
    hideModal() {
      let button = this.$refs.closeButton;
      if (button) button.click()
    },
    confirmUserStatus() {
      let status;
      if (this.userStatusModalData.status == 'ACTIVED') {
        status = 'NO_ACTIVED';
      }
      else {
        status = 'ACTIVED';
      }
      this.$emit('confirm-user-status', { entityId: this.userStatusModalData._id, status: status});
      this.hideModal();
    },
  },
};
</script>
  
<style lang="scss" scoped>

  .modal-usuarios .modal-container {
    width: 550px !important;
    height: 300px;
  }

  .was-validated .form-control:invalid, .form-control.is-invalid {
    background-position: right 1.3rem center !important;
  }

</style>